module.exports = __webpack_public_path__ + "static/getApp-fc87497afa07ad5f0dfc25575ffa058f.svg";